import { Button, ButtonProps } from '@material-ui/core'
import { useCallback, useState } from 'react'
import { useLocation } from 'components/ReactRouterProvider/context'
import api from 'common/api'
import window from 'common/window'
import useSnackbar from 'common/use-snackbar'
import useScid from 'common/use-scid'
import { useCanTestApp } from 'store/user/hooks.ts'
import cookie from 'cookie'

interface PreviewApplicationButtonProps extends ButtonProps {
  configurationId: string
}

type TokenResponse = {
  AccessToken: string
}

const setCookies = (accessToken: string, returnRoute: string) => {
  const orig = cookie.parse(document.cookie).bearer

  document.cookie = cookie.serialize('original_bearer', orig, {
    path: '/',
  })
  document.cookie = cookie.serialize('remembered', returnRoute, {
    path: '/',
  })
  document.cookie = cookie.serialize('original_type', 'AdmissionsOfficer', {
    path: '/',
  })
  document.cookie = cookie.serialize('bearer', accessToken, {
    path: '/student',
  })
  document.cookie = cookie.serialize('lastLoginType', 'Student', { path: '/' })
}

export const PreviewApplicationButton = ({ configurationId, ...rest }: PreviewApplicationButtonProps) => {
  const scid = useScid()
  const { pathname } = useLocation()
  const canTestApp = useCanTestApp()

  const setSnackbar = useSnackbar('An error occurred while attempting to load the test app experience.')

  const [isLoading, setIsLoading] = useState(false)

  const loadAndRedirect = useCallback(() => {
    setIsLoading(true)
    api
      .get<TokenResponse>(
        `/api/colleges/${scid}/integrations/application/configuration/${configurationId}/testApplication/run`,
      )
      .then((loginResponse) => {
        if (loginResponse.AccessToken) {
          setCookies(loginResponse.AccessToken, pathname)
          window.location.href = `/student/app-profile/create/${scid}`
          return
        }
        return Promise.reject()
      })
      .catch(() => {
        setIsLoading(false)
        setSnackbar()
      })
  }, [scid, configurationId, pathname, setSnackbar])

  if (!canTestApp) {
    return null
  }

  return (
    <Button
      {...rest}
      color="primary"
      onClick={loadAndRedirect}
      disabled={isLoading}
    >
      Preview Application as Student
    </Button>
  )
}

export default PreviewApplicationButton
